import script from "./EventList.vue?vue&type=script&setup=true&lang=js"
export * from "./EventList.vue?vue&type=script&setup=true&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=0f42965c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f42965c"]])

export default __exports__